import type { SlateMark } from '@vedalib/rich-text'
import { Editor } from 'slate'

import type { CustomEditor } from '../slate'

export const getTextMark = (editor: CustomEditor) => {
  return Editor.marks(editor) || {}
}

export const setMark = (
  editor: Editor,
  format: SlateMark,
  value: string | number | boolean | undefined,
): void => {
  if (value) {
    Editor.addMark(editor, format, value)
  } else {
    Editor.removeMark(editor, format)
  }
}
